import React, { useEffect, useRef } from 'react';
import lottie from 'lottie-web';
import crossGif from "../../../assets/icons/new_icon/cross.gif";
import truckAnimation from '../../../assets/icons/new_icon/truckbbe.json';

interface Props {
  setShowSummary: any;
  setShowPayment: any;
  setCurrentShipmentStatus: any;
  shippingError: string;
  isManualLegs?: any;
  setShowLegsForm?: any;
  setShowBCScreen?: any;
}

function ShippingPaymentLoading({
  setShowSummary,
  setShowPayment,
  setCurrentShipmentStatus,
  shippingError,
  isManualLegs,
  setShowLegsForm,
  setShowBCScreen,
}: Props) {
  function handleBack() {
    if (isManualLegs) {
      setCurrentShipmentStatus && setCurrentShipmentStatus('packages');
      setShowLegsForm(false);
      // setShowBCScreen(false);
    } else {
      setCurrentShipmentStatus && setCurrentShipmentStatus('summary');
      setShowPayment(false);
      setShowSummary(true);
    }
  }
  const animationContainerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const animationContainer = animationContainerRef.current;
    if (animationContainer) {
      lottie.loadAnimation({
        container: animationContainer,
        animationData: truckAnimation,
        loop: true,
        autoplay: true,
      });
    }
  }, []);

  return (
    <div id='shipping_section'>
      <div className='row'>
        <div className='col-lg-2'></div>
        <div className='col-12 col-lg-8  text-center'>
        {shippingError !== '' ? (
              <div className='py-4'>
                <img
                    src={crossGif}
                    style={{ width: "150px", margin: "auto" }}
                  />
                <h1 className="lex-24-500" style={{ color: "#FD3A3A" }}>Shipment Failed!</h1>
                <p className='shippingparagraph'>
                  Your shipment request could not be sent,
                  <br /> Please try again.
                </p>
            </div>
            ): (
              <div className='py-5'>
                <div
                  ref={animationContainerRef}
                  id='lottie-container'
                  className='lootiemain-container'
                ></div>
                <h1 className='shippingheading'>Shipping your Package!</h1>
                <p className='shippingparagraph'>
                  Once the shipment request is successfully processed,
                  <br /> the page reloads automatically.
                </p>
              </div>
            )}
          
          <div id='shipping_error'>
            {/* {shippingError !== '' && <div>{shippingError}</div>} */}
            {shippingError !== '' && (
              <div
                id='shipping_error_button'
                className='my-0 d-flex m-auto justify-content-center '
              >
                <button
                  type='button'
                  className='btn btn-ubbe-new-back d-flex gap-2'
                  onClick={() => {
                    // back_shipping()
                    handleBack();
                  }}
                >
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='15'
                    height='8'
                    viewBox='0 0 15 8'
                    fill='none'
                  >
                    <path
                      d='M3.03077 0.670207L0.176923 3.5735C0.123077 3.62828 0.0769229 3.69871 0.0461536 3.77697C0.0461536 3.7848 0.0461536 3.79262 0.0384613 3.80045C0.0153844 3.86305 -1.56239e-07 3.92566 -1.53161e-07 3.99609C-1.4632e-07 4.1526 0.0615383 4.30129 0.169231 4.41084L3.03077 7.32979C3.25385 7.55674 3.62308 7.55674 3.84615 7.32979C4.06923 7.10285 4.06923 6.72722 3.84615 6.50028L1.96154 4.58301L14.4231 4.58301C14.7385 4.58301 15 4.31694 15 3.99609C15 3.67524 14.7385 3.40917 14.4231 3.40917L1.96923 3.40917L3.84615 1.49972C3.96154 1.38234 4.01538 1.23365 4.01538 1.08496C4.01538 0.936277 3.96154 0.787591 3.84615 0.670207C3.62308 0.443265 3.26154 0.443265 3.03077 0.670207Z'
                      fill='black'
                    />
                  </svg>
                  Back
                </button>
              </div>
            )}
          </div>
        </div>
        <div className='col-lg-2'></div>
      </div>
    </div>
  );
}

export default ShippingPaymentLoading;
